import React from 'react';
import { useIntl } from 'react-intl';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { Dialog, DialogContent, DialogTitle } from '../../../components/base/Dialog/Dialog';
import Grid from '../../../components/base/Grid/Grid';

export default function ConfiguredViolations(props) {
  const { columns, data, handleClose = () => {} } = props;
  const intl = useIntl();
  const { formatMessage } = intl;
  return (
    <Dialog
      className="configurated-violations-dialog"
      size="xl"
      open
      onClose={handleClose}
    >
      <DialogTitle header={formatMessage({ id: 'configured.violation' })} title={<Icons onClick={handleClose} customIcon icon="close" className="close" />} />
      <DialogContent>
        <div className="grid-wrapper">
          <div className="custom-scroll-theme sticky-table-wrapper">
            <Grid columns={columns} data={data} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
